var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceShock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.9802 44.7936C89.9802 69.548 69.9409 89.5872 45.1866 89.5872C20.4322 89.5872 0 69.548 0 44.7936C0 20.0392 20.0393 0 44.7936 0C69.548 0 89.9802 20.0392 89.9802 44.7936Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5853 52.6523C78.5853 60.9037 71.9055 67.9764 63.2611 67.9764C54.6168 67.9764 47.937 61.2966 47.937 52.6523C47.937 44.0079 54.6168 37.3281 63.2611 37.3281C71.9055 37.3281 78.5853 44.0079 78.5853 52.6523Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.413 44.7936C110.413 69.548 130.452 89.5872 155.206 89.5872C179.961 89.5872 200 69.548 200 44.7936C200 20.0392 179.961 0 155.206 0C130.452 0 110.413 20.0392 110.413 44.7936Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.414 52.6523C121.414 60.9037 128.094 67.9764 136.738 67.9764C144.99 67.9764 152.062 61.2966 152.062 52.6523C152.062 44.0079 145.383 37.3281 136.738 37.3281C128.094 37.3281 121.414 44.0079 121.414 52.6523Z",
    fill: "#3D0E6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8726 134.38C84.8726 142.632 91.5523 149.704 100.197 149.704C108.841 149.704 115.521 143.025 115.521 134.38C115.521 125.736 108.841 119.056 100.197 119.056C91.5523 119.056 84.8726 125.736 84.8726 134.38Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceShock);
export default __webpack_public_path__ + "static/media/face_shock.db3e9d5b5e5075c414c0e3126b5a33a4.svg";
export { ForwardRef as ReactComponent };